/** Mensajes de aviso */
export const MAV1_1 = 'La sesión ha caducado, ingrese al sistema nuevamente. ';
export const MAV1_2 = 'El sistema no está disponible por el momento, favor de volver a intentar. ';
export const ERROR_GET_MUESTRAS = 'Ocurrió un error al descargar imágenes.';
export const ERROR_GET_REPORTE = 'El archivo no se pudo descargar.';
export const ERROR_GET_GUIA_USUARIO_PDF = 'Ocurrió un error al intentar descargar el archivo.';
export const ERROR_SAVE = 'No se ha podido guardar la información, intenta de nuevo.';
export const ERROR_CARGAR_DATOS = 'Ocurrió un error al cargar los datos.';
